import {
  GET_DELIST_TABLE_DATA,
  GET_SIMULATED_DELIST_TABLE_DATA,
  RESET_DELIST_SUMMARY_TABLE_DATA,
  SAVE_DELIST_SUMMARY_TABLE_DATA
} from 'src/constants';
import { axios } from 'src/lib';

// api for getting simulation table columns data as per selected filters
export function fetchPricingSimulationData(
  body: any,
  sourceId: number,
  moduleId: number,
  scenarioId: number
) {
  return axios
    .post<any>(
      `${GET_DELIST_TABLE_DATA}${sourceId}/${moduleId}/${scenarioId}/`,
      body
    )
    .then((response) => response.data);
}

export function resetSimulationData(
  sourceId: number,
  moduleId: number,
  scenarioId: number
) {
  return axios
    .post<any>(
      `${RESET_DELIST_SUMMARY_TABLE_DATA}${sourceId}/${moduleId}/${scenarioId}/`,
      { filter_inputs: [] }
    )
    .then((response) => response.data);
}

export function simulateDelistSimulationData(
  body: any,
  sourceId: number,
  moduleId: number,
  scenarioId: number
) {
  return axios
    .post<any>(
      `${GET_SIMULATED_DELIST_TABLE_DATA}${sourceId}/${moduleId}/${scenarioId}/`,
      body
    )
    .then((response) => response.data);
}

// Api for saving simulation
export function saveSimulationData(
  sourceId: number,
  moduleId: number,
  scenarioId: number
) {
  return axios
    .post<any>(
      `${SAVE_DELIST_SUMMARY_TABLE_DATA}${sourceId}/${moduleId}/${scenarioId}/`,
      {}
    )
    .then((response) => response.data);
}
